import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {carMarketplaceAffiliateReport_template} from "../components/templates/carMarketplaceAffiliateReport_template";

declare var ko: any;
declare var page: any;

export class carMarketplaceAffiliateReport extends vnModule_knockoutJS{

    protected XHRHdl: XMLHttpRequestHandler;
    protected reportTemplate: carMarketplaceAffiliateReport_template;

    protected getModuleName(){
        return "carMarketplaceAffiliateReport";
    }

    buildContent() : Array<Element>{
        this.reportTemplate = new carMarketplaceAffiliateReport_template("carMarketplaceAffiliateReport", this.viewModel, this);
        this.template = this.reportTemplate;

        return [this.reportTemplate.build()];
    }

    public fillPage() : void{
        this.reportTemplate.buildDatePickerCalendar();
        this.getSearchPresetsListData();
    }

    public getListFormData(): void{
        let usrReq_url: string = '/api/carMarketplaceAffiliateReport/list_form_data';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON([])] );

        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onFilterRequestReturn;
        this.XHRHdl.execute();
    }

    protected onFilterRequestReturn(req, obj){
        return function (){
            obj.manageResponse(req, obj, function (){
                let responseParsed = JSON.parse(req.request.response);

                obj.reportTemplate.validationsList.clearMessages();
                obj.updateFilters(responseParsed);
                obj.updateViewModelFromPath();
                obj.reportTemplate.updateColumnsForSelectedAffiliates();
                obj.getListData();
            });

            if(req.request.readyState == 4){
                obj.loadingOut(obj.reportTemplate.builtTemplate);
            }
        };
    }

    protected updateFilters(responseParsed: any){
        this.reportTemplate.setBrandFilterItems(responseParsed.departments);
        this.reportTemplate.setAffiliateFilterItems(responseParsed.affiliates);
        this.reportTemplate.setProviderCompareColumnDefinitions(responseParsed.providerCompare || []);
        this.reportTemplate.setPlacementFilterItems(responseParsed.placements);
        this.reportTemplate.setSpendSourceFilterItems(responseParsed.spendSources || []);
        this.reportTemplate.setTrafficTypeFilterItems(responseParsed.trafficTypes || []);
        this.reportTemplate.setMakeFilterItems(responseParsed.makeFilterItems || []);
    }

    public getListData(): void{
        this.loadingIn(this.reportTemplate.builtTemplate.children.namedItem("list-results"));
        this.reportTemplate.hideExportButton();

        let subViewModel = this.reportTemplate.getViewModelForRequest();
        let baseApiUrl = '/api/carMarketplaceAffiliateReport/list_data';

        // Keep list_data on GET so route/preset restore and runtime data fetch use one transport mode.
        this.sendFilterCall(baseApiUrl, subViewModel, this.onDataRequestReturn, undefined, 'getListData');
    }

    protected onDataRequestReturn(req, obj){
        return function (){
            obj.manageResponse(req, obj, function (){
                let responseParsed = JSON.parse(req.request.response);
                obj.reportTemplate.resetSelectedRows();
                obj.reportTemplate.validationsList.clearMessages();
                obj.updateList(responseParsed);
            });

            if(req.request.readyState == 4 && req.request.status != 0){
                obj.loadingOut(obj.reportTemplate.builtTemplate.children.namedItem("list-results"));
            }
        };
    }

    protected updateList(responseParsed: any) {
        this.reportTemplate.setProviderCompareColumnDefinitions(responseParsed.providerCompare || []);
        this.reportTemplate.setReportData(responseParsed.reportData);
    }

    protected filterMultipleSelectorOnChange(){
        // Keep table structure aligned with selected affiliates/spend sources before fetching rows.
        this.reportTemplate.updateColumnsForSelectedAffiliates();
        this.getListData();
    }

    protected filterDateOnChange(){
        this.getListData();
    }

    protected filterSimpleOnChange(){
        this.getListData();
    }

    public listReorder(){
        this.getListData();
    }

    public getCsvExportData(): void {
        let subViewModel = this.reportTemplate.getViewModelForRequest();
        subViewModel["export"] = true;
        let usrReq_url = '/api/carMarketplaceAffiliateReport/list_data';

        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);

        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onGetCsvExportDataReturn;
        this.XHRHdl.execute();
    }

    protected onGetCsvExportDataReturn(req, obj): Function{
        return function(){
            obj.manageResponse(req, obj, function(){
                let responseParsed = JSON.parse(req.request.response);
                obj.reportTemplate.setExportData(responseParsed.reportData);
            });
        }
    }

    public getUrlParmsFromPath(){
        const urlParams = [];
        const rawQueryString = window.location.href.split('?')[1];

        if(!rawQueryString){
            return urlParams;
        }

        // Decode each key/value defensively so malformed query fragments do not crash preset restore.
        const urlParamsSections = rawQueryString.split("&");
        for(const urlParamSection of urlParamsSections){
            if(!urlParamSection){
                continue;
            }

            const separatorIndex = urlParamSection.indexOf("=");
            const rawKey = separatorIndex >= 0 ? urlParamSection.substring(0, separatorIndex) : urlParamSection;
            const rawValue = separatorIndex >= 0 ? urlParamSection.substring(separatorIndex + 1) : '';
            const decodedKey = this.safeDecode(rawKey);
            let decodedValue: any = this.safeDecode(rawValue);

            if(this.isJsonPayload(decodedValue)){
                try{
                    decodedValue = JSON.parse(decodedValue);
                } catch (e){
                    // Keep raw value when JSON is partial/malformed.
                }
            }

            urlParams[decodedKey] = decodedValue;
        }

        return urlParams;
    }

    private safeDecode(rawValue: string): string{
        try{
            return decodeURIComponent(rawValue);
        } catch (e){
            return rawValue;
        }
    }

    private isJsonPayload(payload: any): boolean{
        if(typeof payload !== 'string'){
            return false;
        }

        try{
            JSON.parse(payload);
        } catch (e){
            return false;
        }

        return true;
    }
}



// WEBPACK FOOTER //
// ./js/modules/carMarketplaceAffiliateReport.ts